<template>
  <div class="c-filter">
    <div class="c-form" style="padding-top: 10px">
      <ElForm label-width="70" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="营销主题标签">
          <el-select v-model="labelId" multiple collapse-tags filterable placeholder="全部">
            <el-option v-for="label in labelTypes" :key="label.id" :value="label.id" :label="label.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem>
          <top-datepick v-model="dateType" @on-select="sendEvent" />
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="$emit('on-down')">数据导出</ElButton>
          <ElButton v-if="authAsynBtn" icon="md-sync" :loading="asyning" @click="$emit('on-refresh')"> 同步数据 </ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray } from '@/common/js/utils'
import TopDatepick from '@/views/material/ranking/components/top-datepick'
export default {
  name: 'TagsFilter',
  components: { TopDatepick },
  props: {
    labelTypes: {
      type: Array
    },
    asyning: {
      type: Boolean
    }
  },
  computed: {
    authAsynBtn() {
      return isArray(this.access) && this.access.includes('M20759')
    }
  },
  data() {
    return {
      dateType: 1,
      beginTime: '',
      labelId: [],
      access: this.$store.state.accessAuth
    }
  },
  methods: {
    sendEvent(val) {
      if (val) {
        if (this.dateType === 3) this.beginTime = moment(val).format('YYYY-MM-01')
        else if (this.dateType === 2) this.beginTime = moment(val).startOf('week').format('YYYY-MM-DD')
        else this.beginTime = moment(val).format('YYYY-MM-DD')
      }
      this.$emit('on-change', {
        dateType: this.dateType,
        beginTime: this.beginTime,
        labelIdsStr: isArray(this.labelId) && this.labelId.length ? this.labelId.join(',') : undefined
      })
    }
  },
  watch: {
    labelId() {
      this.sendEvent()
    }
  }
}
</script>
